module.exports = __webpack_public_path__ + "img/Porto Apartment - 18 of 85.0a986c46.jpeg";